module.exports = __webpack_public_path__ + "d87939dddb2498da49f47a733ec8c4b2.svg";